import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Route, CanLoad, CanActivate, CanActivateChild, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanLoad, CanActivate, CanActivateChild {
	constructor(private authService: AuthService, private router: Router) { }

	canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
		return this.checkLogin(null);
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
		const url: string = state.url;

		return this.checkLogin(url);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
		return this.canActivate(route, state);
	}

	checkLogin(url: string): boolean | Observable<boolean> | Promise<boolean> {
		if (this.authService.getUser()) {
			return true;
		}

		return this.authService.watchUser()
			.pipe(map((user) => {
				if (user) {
					return true;
				}

				this.router.navigate(['/users/login'], { queryParams: { redirectUrl: url } });

				return false;
			}));
	}
}
